export default {"src":"/_next/static/media/icon-arrow-big.159b17c8.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};